import BillingsTaxiDriverDetailsRequest from "../../../../api/raily/billings/taxi-driver/details/billings-taxi-driver-details.request";
import BillingsTaxiDriverDetailsParams from "./billings-taxi-driver-details-params";

const createRequest = (
  params: BillingsTaxiDriverDetailsParams,
): BillingsTaxiDriverDetailsRequest => {
  return {
    billingUuid: params.billingUuid,
  };
};

const billingsTaxiDriverDetailsParamsFactory = {
  createRequest,
};

export default billingsTaxiDriverDetailsParamsFactory;
